module.exports = __webpack_public_path__ + "static/media/Robofriends.9730fefc.webp";